import { Component, OnInit } from '@angular/core';


declare var bootbox: any;
declare var $: any;

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {



  slides = [
    { image: "../../assets/img/slides img/1.jpg", caption: "Capture life' moments." },
    { image: "../../assets/img/slides img/2.jpg", caption: "Elevate your perspective." },
    { image: "../../assets/img/slides img/3.jpg", caption: "Teamwork creates magic." },
    { image: "../../assets/img/slides img/4.jpg", caption: "Transforming visual stories." },
    { image: "../../assets/img/slides img/5.jpg", caption: "Crafting brand narratives." },
    { image: "../../assets/img/slides img/6.jpg", caption: "Capture life' moments." },
    { image: "../../assets/img/slides img/7.jpg", caption: "Elevate your perspective." },
    { image: "../../assets/img/slides img/8.jpg", caption: "Teamwork creates magic." },
    { image: "../../assets/img/slides img/9.jpg", caption: "Transforming visual stories." },
    { image: "../../assets/img/slides img/11.jpg", caption: "Crafting brand narratives." },
    { image: "../../assets/img/slides img/12.jpg", caption: "Capture life' moments." },
    { image: "../../assets/img/slides img/13.jpg", caption: "Elevate your perspective." },
    { image: "../../assets/img/slides img/14.jpg", caption: "Teamwork creates magic." },
    { image: "../../assets/img/slides img/16.jpg", caption: "Transforming visual stories." },
    { image: "../../assets/img/slides img/27.jpg", caption: "Crafting brand narratives." },
    { image: "../../assets/img/slides img/31.jpg", caption: "Teamwork creates magic." },
    { image: "../../assets/img/slides img/32.jpg", caption: "Transforming visual stories." },
    { image: "../../assets/img/slides img/33.jpg", caption: "Crafting brand narratives." },
    { image: "../../assets/img/slides img/34.jpg", caption: "Capture life' moments." },
    { image: "../../assets/img/slides img/35.jpg", caption: "Elevate your perspective." },
    { image: "../../assets/img/slides img/36.jpg", caption: "Teamwork creates magic." },
    { image: "../../assets/img/slides img/38.jpg", caption: "Crafting brand narratives." },
    { image: "../../assets/img/slides img/p16.jpg", caption: "Crafting brand narratives." },
    
  ];
  
  currentIndex = 0;

  constructor() { }

  ngOnInit(): void {
    
    this.startSlideshow();
    // ANIMATION

    $(document).ready(function($) {
  
      // Function which adds the 'animated' class to any '.animatable' in view
      var doAnimations = function() {
        
        // Calc current offset and get all animatables
        var offset = $(window).scrollTop() + $(window).height(),
            $animatables = $('.animatable');
        
        // Unbind scroll handler if we have no animatables
        if ($animatables.length == 0) {
          $(window).off('scroll', doAnimations);
        }
        
        // Check all animatables and animate them if necessary
        $animatables.each(function(i) {
           var $animatable = $(this);
          if (($animatable.offset().top + $animatable.height() -1) < offset) {
            $animatable.removeClass('animatable').addClass('animated');
          }
        });
    
      };
      
      // Hook doAnimations on scroll, and trigger a scroll
      $(window).on('scroll', doAnimations);
      $(window).trigger('scroll');
    
    });

    //

    $(document).ready(function() {
      $("#myModal").modal('show');
    });
    
    setTimeout(function() {
      $('#myModal').modal('hide');
    }, 3000);

    $(".slide img").on("click" , function(){
      $(this).toggleClass('zoomed');
      $(".overlay").toggleClass('active');
      })

    $(document).ready(function(){ 
      $(window).scroll(function(){ 
          if ($(this).scrollTop() > 100) { 
              $('#scroll').fadeIn(); 
          } else { 
              $('#scroll').fadeOut(); 
          } 
      }); 
      $('#scroll').click(function(){ 
          $("html, body").animate({ scrollTop: 0 }, 600); 
          return false; 
      }); 
    });

  }

  

  prev(){
    document.getElementById('slider-container').scrollLeft -= 270;
  }
  
  next()
  {
    document.getElementById('slider-container').scrollLeft += 270;
  }
  

  startSlideshow() {
    setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    }, 5000); // Change slide every 2 seconds
  }
}
